export default __webpack_public_path__ + "static/media/bulk-student.baf1861a.csv";